import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const reorderPickSessionPriorityFilters = {
  name: "reorderPickSessionPriorityFilters" as const,
  input: z.object({
    filters: z.array(z.object({ id: zExt.objectId(), position: z.number() })),
  }),
  output: z.object({ success: z.boolean() }),
};
